export const EBILLS_STATE_QUERY_PARAM_KEY = 'syncState';
